export const SpinnerBorder = () => {
  return (
    <div className="w-10 h-10 border-4 border-white/40 border-t-white rounded-full animate-spin"></div>
  );
};

export const SpinnerEaseInOut = () => {
  return (
    <div className="w-10 h-10 relative mx-auto inline-block">
      <div className="absolute top-0 left-0 w-full h-full bg-gray-800 opacity-60 rounded-full animate-bounce"></div>
      <div className="absolute top-0 left-0 w-full h-full bg-gray-800 opacity-60 rounded-full animate-bounce delay-1000"></div>
    </div>
  );
};
